import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = ({ children, className, ...otherProps }) => (
    <div className={`gds-modal__body  ${className}`} {...otherProps}>
        {children}
    </div>
);

ModalBody.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default ModalBody;
